

































































import {
  AgeAgeDTO,
  AgeManagerService,
  LiveManagementCreateLivecarpItemRequest,
} from "@/common/api";
import { LANG } from "@/common/constant";
import QPaginate from "@/common/qPaginate.vue";
import QSearch from "@/common/qSearch.vue";
import QTableHeader from "@/common/qTableHeader.vue";
import { formatImageUrl } from "@/common/utils";
import store from "@/store";
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "LivePdfComponent",
  components: {
    QSearch,
    QPaginate,
    QTableHeader,
  },
})
export default class LivePdfComponent extends Vue {

  get validItems() {
    if (this.config.method === "all") {
      return this.items;
    }

    const regex = /^([\dA-Za-z]+)-(\d+)$/;

    if (
      regex.test(this.config.range.start) &&
      regex.test(this.config.range.end) &&
      this.config.range.start.split("-")[0] ===
        this.config.range.end.split("-")[0]
    ) {
      const start = Number(this.config.range.start.split("-")[1]);
      const end = Number(this.config.range.end.split("-")[1]);

      const filteredData = this.items.filter((item) => {
        const match = item.code.match(regex);
        if (!match) {
          return false;
        }
        const numberPart = Number.parseInt(match[2]);

        return numberPart >= start && numberPart <= end;
      });

      return filteredData;
    }

    return [];
  }
  public items = [] as LiveManagementCreateLivecarpItemRequest[];
  public ages = [] as AgeAgeDTO[];
  public config = {
    method: "all",
    range: {
      start: "",
      end: "",
    },
    is_display_code: true,
    date: {
      year: null,
      month: null,
      day: null,
    },
    signature: "",
  };

  public image = null;

  public sex = {
    male: this.translateAttribute("live_preview.male", LANG.JA),
    female: this.translateAttribute("live_preview.female", LANG.JA),
    unknown: this.translateAttribute("live_preview.unknown", LANG.JA),
  };

  public sexEn = {
    male: this.translateAttribute("live_preview.male", LANG.EN),
    female: this.translateAttribute("live_preview.female", LANG.EN),
    unknown: this.translateAttribute("live_preview.unknown", LANG.EN),
  };

  public imageUrl(name) {
    return formatImageUrl(name, "342x485");
  }

  public created() {
    this.items = store.state.Live.items;
    this.config = store.state.Live.config;
    this.image = store.state.Live.image;
    this.getListAge();
  }

  public mounted() {
    let base = document.createElement("link");
    base.setAttribute("rel", "stylesheet");
    base.setAttribute(
      "href",
      "https://cdnjs.cloudflare.com/ajax/libs/paper-css/0.4.1/paper.css",
    );
    document.querySelector("head").append(base);

    base = document.createElement("link");
    base.setAttribute("rel", "stylesheet");
    base.setAttribute("href", "/css/pdf.css");
    document.querySelector("head").append(base);
  }

  public translateAttribute(attributeName, lang) {
    const currentLang = lang ? lang : LANG.JA;
    return this.$t(attributeName, `${currentLang}`);
  }

  private async getListAge() {
    const result = await AgeManagerService.adminAge({});

    this.ages = result.data.ages;
  }
}
